// extracted by mini-css-extract-plugin
export var colorAccuracy = "style-module--color-accuracy--db533";
export var compareContainer = "style-module--compare-container--c42fa";